module.exports = __webpack_public_path__ + "resources/group-member-select-301a10779cbbf76f4790a1972c655369.svg";